import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { useLang } from "@/context/LanguageContext";
import { packageMeta } from "@/lib/packages";


import { ArrowLeft,ArrowRight, MapPin, Clock, Wind, CheckCircle, AlertTriangle, ExternalLink } from "lucide-react";

import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import BookingForm from "@/components/BookingForm";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import FAQSection from "@/components/FAQSection";

export default function CostaRica() {
  const { t, setLang } = useLang(); // Get the setter from your context

  
  /*
  useEffect(() => {
    setLang("en"); // Force English on this specific page on mount
  }, [setLang]);
  */
  const scrollToBook = (pkgId) => {
      const el = document.getElementById("book");
      if (el) {
        window.dispatchEvent(new CustomEvent("prefill-package", { detail: pkgId }));
        el.scrollIntoView({ behavior: "smooth" });
      }
    };
  useEffect(() => {
    //setLang("en"); // Force English on this specific page on mount
    window.scrollTo(0, 0);
    document.title = "Tandem Paragliding in Costa Rica | Dominical & Rivas";

    
    // Meta Description Setup
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content", 
      "Book your tandem paragliding flight in Costa Rica. Take off from Rivas mountains or Dominical beach with stunning views of Perez Zeledon and the Pacific Ocean."
    );

    // Remove any previous JSON-LD schema to ensure only the current one stays
    document.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
      script.remove();
    });

    // SEO Schema Setup (JSON-LD) with 3 added products
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "@id": "https://paraglidetour.com/costarica",
          "name": "Parapente Perez Zeledon",
          "telephone": "+50683455135", // Update with the correct phone number if needed
          "url": "https://www.parapenteperezzeledon.com/",
          "image": "https://ik.imagekit.io/paraglidetour/parapente-perez-zeledon-tandem-costa-rica-puravda-006.jpeg?updatedAt=1783540168700",
          "sameAs": [
            "https://www.instagram.com/paragliding_costa_rica/",
            "https://www.instagram.com/paraglidingeveryday/",
            "https://www.tiktok.com/@tandemparaglidecr/"
          ],
          "priceRange": "$115.00 - $200.00",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Rivas,Perez Zeledon",
            "addressRegion": "San Jose",
            "addressCountry": "CR"
          }
        },
        // Product 1: Rivas Mountain Flight
        {
          "@type": "Product",
          "name": "Paragliding Flight in Rivas Mountain- Costa Rica Pura Vida",
          "description": "The classic and most exclusive mountain takeoff in Perez Zeledon. An incredible scenic flight with a complete view of the valley and mountains around Chirripó Peak.",
          "url": "https://paraglidetour.com/tours/classic_rivas",
          "image": "https://ik.imagekit.io/paraglidetour/parapente-perez-zeledon-tandem-costa-rica-puravda-019.jpeg?updatedAt=1783540170527",
          "provider": {
            "@id": "https://paraglidetour.com/costarica/",
            "name": "Parapente Perez Zeledon"
          },
          "offers": {
            "@type": "Offer",
            "priceCurrency": "USD",
            "price": "115.00",
            "url": "https://paraglidetour.com/tours/classic_rivas",
            "availability": "https://schema.org/InStock",
            "validFrom": "2026-01-01T08:00:00+00:00",
            "priceValidUntil": "2026-11-30T23:59:59+00:00",
            "priceSpecification": {
              "@type": "UnitPriceSpecification",
              "priceType": "https://schema.org/StrikethroughPrice",
              "price": "140.00",
              "priceCurrency":  "USD",
            },
          }
        },
        // Product 2: Dominical Beach Flight
        {
          "@type": "Product",
          "name": "Paragliding Flight in Dominical Beach - Costa Rica",
          "description": "Feel the ocean breeze. A flight soaring over the crystal-clear waters and lush jungle of Dominical.",
          "url": "https://paraglidetour.com/tours/dominical_coastal",
          "image": "https://ik.imagekit.io/paraglidetour/parapente-perez-zeledon-tandem-costa-rica-puravda-011.jpeg?updatedAt=1783540167479",
          "provider": {
            "@id": "https://paraglidetour.com/costarica/",
            "name": "Parapente Perez Zeledon"
          },
          "offers": {
            "@type": "Offer",
            "priceCurrency": "USD",
            "price": "135.00",
            "url": "https://paraglidetour.com/tours/dominical_coastal",
            "availability": "https://schema.org/InStock",
            "validFrom": "2026-01-01T08:00:00+00:00",
            "priceValidUntil": "2026-11-30T23:59:59+00:00",
            "priceSpecification": {
              "@type": "UnitPriceSpecification",
              "priceType": "https://schema.org/StrikethroughPrice",
              "price": "150.00",
              "priceCurrency":  "USD",
            },
          }
        },
        // Product 3: Dominical Beach VIP
        {
          "@type": "Product",
          "name": "VIP Paragliding Flight Dominical Beach - Costa Rica",
          "description": "The ultimate experience. Double the airtime or acrobatic maneuvers for you to enjoy every second soaring over the Pacific Ocean and the entire coastline.",
          "url": "https://paraglidetour.com/tours/adrenaline",
          "image": "https://ik.imagekit.io/paraglidetour/parapente-perez-zeledon-tandem-costa-rica-puravda-006.jpeg?updatedAt=1783540168700",
          "provider": {
            "@id": "https://paraglidetour.com/costarica/",
            "name": "Parapente Perez Zeledon"
          },
          "offers": {
            "@type": "Offer",
            "priceCurrency": "USD",
            "price": "200.00",
            "availability": "https://schema.org/InStock",
            "url": "https://paraglidetour.com/tours/adrenaline",
            "validFrom": "2026-01-01T08:44"
          }
        },
        {
          "@type": "QAPage",
          "mainEntity": [
             {
                    "@type": "Question",
                    "name": "Do I need experience to fly tandem paragliding?",
                    "text": "Do I need experience to fly tandem paragliding?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "None. In a tandem flight you simply enjoy the view while a certified pilot handles everything. We fly people from 5 to 85 years old."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Is there a weight limit for tandem paragliding?",
                    "text": "Is there a weight limit for tandem paragliding?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Maximum passenger weight is 135 kg (297 lbs). BMI under 33 for safety."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How long does a paragliding flight last?",
                    "text": "How long does a paragliding flight last?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Standard flights last 20–30 minutes. Whale Tail and long-distance flights can extend up to 45–60 minutes."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What happens if the weather is bad?",
                    "text": "What happens if the weather is bad?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Safety first. If conditions are unsuitable we reschedule at no cost or refund your deposit."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Do you provide photos and video of the flight?",
                    "text": "Do you provide photos and video of the flight?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Yes — GoPro and Insta360 add-ons are available on all flights. Drone footage on request. Birthday flyers get GoPro footage free."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Can I pay in cash or crypto?",
                    "text": "Can I pay in cash or crypto?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Online deposit is via card (Stripe). The remainder can be paid in cash (USD/CRC), card, or Bitcoin at the launch site."
                    }
                }
          ]
        }
      ]
    };

    const scriptSchema = document.createElement('script');
    scriptSchema.setAttribute('id', 'seo-schema');
    scriptSchema.setAttribute('type', 'application/ld+json');
    scriptSchema.textContent = JSON.stringify(schemaData);
    document.head.appendChild(scriptSchema);

    return () => {
      if (scriptSchema && scriptSchema.parentNode) {
        scriptSchema.parentNode.removeChild(scriptSchema);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-sand text-jungle">
      <Header />
      {/* <TrustBar /> */}

      {/* SEO Intro Section with Background Image */}
      <section 
        className="pt-40 pb-16 relative bg-cover bg-center border-b border-jungle/10"
        style={{ backgroundImage: `url('https://ik.imagekit.io/paraglidetour/the_best_paragliding_tour/parapente_perez_zeledon_pura_vida.webp')` }}
      >
                
                <div className="absolute inset-0 bg-jungle/75"></div>

        <div className="max-w-2xl mx-auto px-6 md:px-12 text-center relative z-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-overline text-[10px] text-zinc-100 hover:text-white transition-colors mb-6"
          >
            <ArrowLeft size={14} /> BACK TO HOME PAGE
          </Link>
          <div className="font-overline text-white text-xs mb-3">Adventure in Costa Rica</div>
          <h1 className="font-display text-4xl md:text-5xl text-white leading-tight mb-6">
            Tandem Paragliding in Costa Rica
          </h1>
          <p className="text-zinc-200 text-base md:text-lg max-w-3xl mx-auto leading-relaxed">
            Discover the thrill of <strong className="text-white">paragliding in Costa Rica</strong>. Our tandem flights are the ultimate experience for those seeking adrenaline and a deep connection with nature in <strong className="text-white">Perez Zeledon</strong>. Soar through the skies of <strong className="text-white">Rivas</strong> or enjoy an unforgettable panoramic view over the lush jungles and Pacific waters of <strong className="text-white">Dominical</strong>.
          </p>
        </div>
      </section>

      {/* Flight Packages Section (3 Options) */}
      <section className="pt-16 md:pt-24 pb-8 bg-sand">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl md:text-4xl text-jungle mb-4">
              Choose Your Flight Route
            </h2>
            <p className="text-forest text-lg">
              Exclusive options taking off from the best spots in the region.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Rivas Mountain Flight */}
            <article className="bg-white rounded-2xl border border-jungle/15 shadow-sm hover:shadow-lg transition-shadow relative overflow-hidden flex flex-col">
               <div className="absolute top-0 right-0 bg-terracotta text-white font-overline text-[10px] px-3 py-1 rounded-bl-lg z-10">
                MOST LOVED
              </div>   
              <img 
                src="https://ik.imagekit.io/paraglidetour/parapente-perez-zeledon-tandem-costa-rica-puravda-019.jpeg?updatedAt=1783540170527" 
                alt="Flight in Rivas Mountains" 
                className="w-full h-48 object-cover"
              />
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <div className="flex items-center gap-3 mb-4 text-terracotta">
                  <MapPin size={24} />
                  <h3 className="font-display text-2xl text-jungle">Rivas Mountains</h3>
                </div>
                <p className="text-forest mb-6 flex-grow">
                  The classic mountain takeoff in Perez Zeledon. An incredible scenic flight with a complete view of the valley and surrounding nature.
                </p>
                
                <ul className="space-y-3 mb-8">
                  <li className="flex items-center gap-2 text-forest">
                    <Clock size={18} className="text-terracotta" />
                    <span>Flight duration: <strong>15 to 20 minutes</strong></span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <Wind size={18} className="text-terracotta" />
                    <span>Mountain thermal flying</span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <CheckCircle size={18} className="text-jungle" />
                    <span>Instruction included</span>
                  </li>
                </ul>
              <div className="flex flex-col gap-2 items-start">
                      <Link to="/tandem/rivas_mountain" data-testid="package-details-btn-rivas_mountain" className="btn-primary text-center justify-center font-overline text-[20px] text-center justify-center text-terracotta hover:text-forest transition-colors">
                        Details →
                      </Link>
                     
              </div>
                <div className="border-t border-jungle/10 pt-6 mt-auto">
                  <div className="flex flex-col mb-4">
                    
                    <span className="line-through text-forest/70 text-sm font-medium">Was $140.00</span>
                    <span className="font-display text-4xl text-jungle">$120<span className="text-xl">.00</span></span>
                     
                  </div>
                  <a href="https://wa.me/50683455135" className="btn-primary text-center justify-center">
                    Book Mountain Flight
                    <img 
                      src="https://ik.imagekit.io/paraglidetour/whatsapp-50683455135-parapente-puravida.svg" 
                      alt="WhatsApp Icon"
                      className="inline-block ml-2 w-4 h-4"
                    ></img>
                    </a>
            
                   





                </div>
              </div>
            </article>

            {/* Dominical Beach Flight (Standard) */}
            <article className="bg-white rounded-2xl border border-jungle/15 shadow-sm hover:shadow-lg transition-shadow relative overflow-hidden flex flex-col">
                        
              <img 
                src="https://ik.imagekit.io/paraglidetour/parapente-perez-zeledon-tandem-costa-rica-puravda-011.jpeg?updatedAt=1783540167479" 
                alt="Flight in Dominical Beach" 
                className="w-full h-48 object-cover"
              />
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <div className="flex items-center gap-3 mb-4 text-terracotta">
                  <MapPin size={24} />
                  <h3 className="font-display text-2xl text-jungle">Dominical Beach</h3>
                </div>
                <p className="text-forest mb-6 flex-grow">
                  Feel the ocean breeze. A breathtaking flight soaring over the crystal-clear waters and coastline of Dominical.
                </p>
                
                <ul className="space-y-3 mb-8">
                  <li className="flex items-center gap-2 text-forest">
                    <Clock size={18} className="text-terracotta" />
                    <span>Flight duration: <strong>10 to 15 minutes</strong></span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <Wind size={18} className="text-terracotta" />
                    <span>Pacific coastline views</span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <CheckCircle size={18} className="text-jungle" />
                    <span>Instruction included</span>
                  </li>
                </ul>
                  
                  <div className="flex flex-col gap-2 items-start">
                      <Link to="/tandem/dominical_coastal" data-testid="package-details-btn-dominical_coastal" className="btn-primary text-center justify-center font-overline text-[20px] text-center justify-center text-terracotta hover:text-forest transition-colors">
                        Details →
                      </Link>
                     
              </div>
                <div className="border-t border-jungle/10 pt-6 mt-auto">
                  <div className="flex flex-col mb-4">
                    <span className="line-through text-forest/70 text-sm font-medium">Was $150.00</span>
                    <span className="font-display text-4xl text-jungle">$150<span className="text-xl">.00</span></span>
                  </div>
                  <a href="https://wa.me/50683455135" className="btn-primary w-full text-center justify-center">
                    Book Coastal Flight
                     <img 
                      src="https://ik.imagekit.io/paraglidetour/whatsapp-50683455135-parapente-puravida.svg" 
                      alt="WhatsApp Icon"
                      className="inline-block ml-2 w-5 h-5"
                    ></img>
                  </a>
                </div>
              </div>
            </article>

            {/* Dominical Beach VIP */}
            <article className="bg-white rounded-2xl border border-jungle/15 shadow-sm hover:shadow-lg transition-shadow relative overflow-hidden flex flex-col">
              <div className="absolute top-0 right-0 bg-jungle text-white font-overline text-[10px] px-3 py-1 rounded-bl-lg z-10">
                VIP / EXCLUSIVE
              </div>
              <img 
                src="https://ik.imagekit.io/paraglidetour/parapente-perez-zeledon-tandem-costa-rica-puravda-006.jpeg?updatedAt=1783540168700" 
                alt="VIP Flight in Dominical Beach" 
                className="w-full h-48 object-cover"
              />
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <div className="flex items-center gap-3 mb-4 text-terracotta">
                  <MapPin size={24} />
                  <h3 className="font-display text-2xl text-jungle">Dominical Beach VIP</h3>
                </div>
                <p className="text-forest mb-6 flex-grow">
                  The ultimate experience. Extended airtime for you to enjoy every second soaring over the Pacific Ocean and lush jungle.
                </p>
                
                <ul className="space-y-3 mb-8">
                  <li className="flex items-center gap-2 text-forest">
                    <Clock size={18} className="text-terracotta" />
                    <span>Flight duration: <strong>up to 25 mins</strong></span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <Wind size={18} className="text-terracotta" />
                    <span>Exclusive extended flight</span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <CheckCircle size={18} className="text-jungle" />
                    <span>Instruction included</span>
                  </li>
                </ul>
                  <div className="flex flex-col gap-2 items-start">
                      <Link to="/tandem/whale_tail" data-testid="package-details-btn-whale_tail" className="btn-primary text-center justify-center font-overline text-[20px] text-center justify-center text-terracotta hover:text-forest transition-colors">
                        Details →
                      </Link>
                     
              </div>
                <div className="border-t border-jungle/10 pt-6 mt-auto">
                  <div className="flex flex-col mb-4">
                    <span className="line-through text-forest/70 text-sm font-medium">Was $200.00</span>
                    <span className="font-display text-4xl text-jungle">$160<span className="text-xl">.00</span></span>
                  </div>
                  <a href="https://wa.me/50683455135" className="btn-primary w-full text-center justify-center">
                    Book VIP Flight
                     <img 
                      src="https://ik.imagekit.io/paraglidetour/whatsapp-50683455135-parapente-puravida.svg" 
                      alt="WhatsApp Icon"
                      className="inline-block ml-2 w-5 h-5"
                    ></img>
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      
      <Gallery />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}